import React, { useCallback } from "react";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { NewEntity } from "@components/onboarding/flows/NewEntity";
import { useLegacyPlusEntityLimit } from "./useLegacyPlusEntityLimit";
import { LegacyPlusEntityLimitModal } from "./LegacyPlusEntityLimitModal";

export const NewEntityLegacyPlusGuard: React.FC = () => {
    const navigate = useStateAwareNavigate();
    const { isAtLimit } = useLegacyPlusEntityLimit();

    const handleHide = useCallback(() => {
        navigate("/accounts");
    }, [navigate]);

    if (isAtLimit) {
        return <LegacyPlusEntityLimitModal show onHide={handleHide} />;
    }

    return <NewEntity />;
};
